import antdData from 'antd/lib/locale-provider/ru_RU'
import localeData from 'react-intl/locale-data/ru'

const messages = {
  'topBar.typeToSearch': 'Поиск...',
  'topBar.profileMenu.hello': 'Привет',
  'topBar.profileMenu.role': 'Роль',
  'topBar.profileMenu.email': 'Емайл',
  'topBar.profileMenu.phone': 'Телефон',
  'topBar.profileMenu.manageMembership': 'Управление членством',
  'topBar.profileMenu.editProfile': 'Редактировать профиль',
  'topBar.profileMenu.changePassword': 'Изменить пароль',
  'topBar.profileMenu.logout': 'Выйти',
  'member.profile.emailAddressTitle': 'Адрес электронной почты',
  'member.profile.emailAddress': 'Введите адрес электронной почты',
  'member.profile.validEmail': 'Введен неверный E-mail!',
  'member.profile.enterEmail': 'Пожалуйста, введите E-mail!',
  'member.profile.saveButton': 'Сохранить',
}

export default {
  locale: 'ru-RU',
  antdData,
  localeData,
  messages,
}
